import React, { useState } from "react";
import { Link, useNavigate, useLocation, useOutletContext, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { brand } = useOutletContext();
  const { brand: key } = useParams();
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const dark = brand.key === "blackpekoe";
  const fg = dark ? "#F5F2EB" : "#2D2622";
  const muted = dark ? "rgba(245,242,235,0.7)" : "#5C5753";
  const cardBg = dark ? "rgba(255,255,255,0.05)" : "white";
  const cardBorder = dark ? "rgba(255,255,255,0.1)" : "rgba(45,38,34,0.1)";

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(identifier, password);
      // Brand mismatch: deny customer logging into wrong brand storefront
      if (u.role === "customer" && u.brand && u.brand !== brand.key) {
        toast.error(`This account belongs to ${u.brand.toUpperCase()}. Switch to that brand to continue.`);
        setLoading(false);
        return;
      }
      toast.success(`Welcome back, ${u.store_name || u.name}`);
      nav(loc.state?.from || `/b/${key}/shop`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const codePrefix = brand.store_prefix.replace("-S", "-S1001");

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" style={{ color: fg }}>
      <div className="w-full max-w-md rounded-2xl p-8 shadow-sm fade-up" style={{ background: cardBg, border: `1px solid ${cardBorder}` }}>
        <p className="overline" style={{ color: muted }}>{brand.name} • Franchise sign in</p>
        <h1 className="font-heading font-bold text-3xl mt-2">Welcome back</h1>
        <p className="mt-2 text-sm" style={{ color: muted }}>Authorised franchise partners only. If you don't have credentials, please email <a href="mailto:admin@bigbillionfnb.com" className="font-semibold" style={{ color: brand.primary }}>admin@bigbillionfnb.com</a>.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label>Email or Store code</Label>
            <Input data-testid="login-identifier" required value={identifier} onChange={(e) => setIdentifier(e.target.value)} placeholder={`you@example.com or ${codePrefix}`} />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full text-white" style={{ background: brand.primary }}>
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>

        <p className="text-sm mt-6 text-center" style={{ color: muted }}>
          Need access? <a href="mailto:admin@bigbillionfnb.com" className="font-semibold hover:underline" style={{ color: brand.primary }} data-testid="login-contact">Contact our team</a>
        </p>
      </div>
    </div>
  );
}
